// extracted by mini-css-extract-plugin
export default {"resizable_popup":"DebugCC_resizable_popup__rAUep","scrollable_content":"DebugCC_scrollable_content__kEfpw"};